import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import './ProgramHighlight.css';

const ProgramHighlight = () => {
  return (
    <section className="program-highlight fade-in-up">
      <div className="container">
        <div className="program-highlight-card">
          <div className="program-highlight-icon">
            <FaCalendarAlt />
          </div>
          <div className="program-highlight-text">
            <h2 className="program-highlight-title">Conference Program Now Available</h2>
            <p className="program-highlight-desc">
              Get an overview of what will happen across the conference, day by day, together
              with the delegate master timetable for 1&ndash;4 December 2026.
            </p>
          </div>
          <Link to="/information/program" className="program-highlight-cta">
            View the Program <FaArrowRight className="program-highlight-cta-icon" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProgramHighlight;
